<template>
  <div class="bar" id="bar" ref="bar"></div>
</template>

<script>
export default {
  name: "bar",
  props: ["needData"],
  data() {
    return {};
  },
  mounted() {
    // setTimeout(() => {
    //   this.bar(this.needData);
    // }, 200);
  },
  watch: {
    needData() {
      this.bar(this.needData);
    },
  },
  methods: {
    bar(param) {
      let myEchart = this.$echarts.init(document.getElementById("bar"));
      // var echarts = require("echarts");
      // console.log(param);

      var year = [];
      var leftsewage = [];
      var productionsewage = [];
      param.forEach((item) => {
        year.push(item.year);
        leftsewage.push(item.leftsewage);
        productionsewage.push(item.productionsewage);
      });

      let option = {
        legend: {
          top: "2%",
          left: "40%",
          itemGap: 20,
          itemWidth: 12,
          itemHeight: 12,
          icon: "rect",
          data: ["生产污水", "生活污水"],
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        yAxis: {
          type: "value",
          name: "（吨）",
          nameTextStyle: {
            color: " #a5b6bb",
            fontSize: 12,
            padding: [0, 20, 0, 0],
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#4f5d64",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#aebfc4",
          },
        },
        xAxis: {
          type: "category",
          data: year,
          axisLine: {
            lineStyle: {
              color: "#4f5d64",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#aebfc4",
          },
        },
        series: [
          {
            name: "生产污水",
            type: "bar",
            barWidth: 16,
            barGap: "5%",
            data: productionsewage,
            itemStyle: {
              barBorderRadius: [1, 1, 0, 0],
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(134,198,215,.2)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(134,198,215,1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          {
            name: "生活污水",
            type: "bar",
            barWidth: 16,
            barGap: "5%",
            data: leftsewage,
            itemStyle: {
              barBorderRadius: [1, 1, 0, 0],
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(218,156,45,.2)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(218,156,45,1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };

      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.bar {
  width: 100%;
  height: 100%;
  z-index: 10;
}
</style>